<template>
  <page>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New GST Status
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <download-csv :data="items" name="GSTStatList.csv" :labels="csvHeaders">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn class="mx-2" fab dark small color="primary" v-on="on">
                <v-icon dark>mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Download CSV</span>
          </v-tooltip>
        </download-csv>
        <v-flex xs12 class="mt-1">
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-flex>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.gstStat }}</td>
                <td class="text-xs-left">{{ row.item.gstStatDesc }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item.gstStat)"
                    query
                    @query="doQuery(row.item.gstStat)"
                    remove
                    @remove="doDelete(row.item.gstStat)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
      <confirm ref="confirmDelete"> Are you sure you want to delete the selected GST Status? ({{ selectedGSTStat }}) </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [{ text: 'GST Status', value: 'gstStat' }, { text: 'Description', value: 'gstStatDesc' }, TableConst.tableActionHeader],
      selectedGSTStat: null,
      csvHeaders: {
        gstStat: 'GST Status',
        gstStatDesc: 'GST Description'
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const apiURI = this.menu.getGSTStatList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          this.items = []
          const { data } = result.data
          if (data) {
            data.map((gstStat) => {
              const convertList = {
                gstStat: gstStat.gstStat,
                gstStatDesc: gstStat.gstStatDesc
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doNew() {
      this.$router.push({
        name: 'gstStatDet',
        params: {
          gstStat: 'new',
          gstStatMode: 'New'
        }
      })
    },
    doReview(gstStat) {
      this.$router.push({
        name: 'gstStatDet',
        params: {
          gstStat,
          gstStatMode: 'Review'
        }
      })
    },
    doQuery(gstStat) {
      this.$router.push({
        name: 'gstStatDet',
        params: {
          gstStat,
          gstStatMode: 'Query'
        }
      })
    },
    async doDelete(gstStat) {
      const apiURI = this.menu.checkDeleteGSTStat
      const apiURI2 = this.menu.deleteGSTStat
      if (gstStat && apiURI && apiURI2) {
        try {
          const expand = { gstStat }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedGSTStat = gstStat
          const prompt = await this.$refs.confirmDelete.doPopUp()
          if (prompt) {
            const result = await this.$http.delete(expandURI(apiURI2, expand))
            const { data } = result
            this.notify(data)
            this.fetchData()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.gstParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
